<script setup lang="ts">
defineProps<{
    expanded: boolean;
}>();
</script>

<template>
    <i class="iconfont icon-fill-down ui-group-expand-icon" :class="{ 'is-collapsed': !expanded }" />
</template>

<style lang="scss" scoped>
.ui-group-expand-icon {
    flex-shrink: 0;
    font-size: 12px;
    line-height: 1;
    transform: rotate(0deg);
    transform-origin: center;
    transition: transform var(--transition-base);

    &.is-collapsed {
        transform: rotate(-90deg);
    }
}
</style>
